export const sequenceEqualsAsync = async (first, second, comparer) => {
    const firstArray = await first.toArray();
    const secondArray = await second.toArray();
    if (firstArray.length !== secondArray.length) {
        return false;
    }
    for (let i = 0; i < firstArray.length; i++) {
        const firstResult = firstArray[i];
        const secondResult = secondArray[i];
        if (await comparer(firstResult, secondResult) === false) {
            return false;
        }
    }
    return true;
};
